<header>
  <div class="header-container">
    <div class="row w-100">
      <div class="col-12">
        <nav class="navbar align-items-stretch">
          <div class="navbar-brands">
            <a class="navbar-brand d-inline-block" routerLink="/">
              <img src="{{ logoUrl }}" class="img-fluid" alt="logo" />
            </a>
          </div>
          <app-unauthenticated-header *ngIf="!authManager.isAuthenticated" />
          <app-authenticated-header *ngIf="authManager.isAuthenticated" />
        </nav>
      </div>
      <ng-container *appFeatureFlag="'isExtraBannerDetailsAvailable'">
        <div *ngIf="bannersDetails && bannersDetails.length > 0" class="header-infoline">
          <div *ngFor="let bannerDetail of bannersDetails">
            <div class="header-infoline-body" *ngIf="bannerDetail.isEnabled" [ngStyle]="{
                'background-color': bannerDetail.color,
                'border-color': bannerDetail.color,
              }">
              {{ bannerDetail.message }}
            </div>
          </div>
        </div>
        <ng-container *ngIf="authManager.isAuthenticated && authManager.isAdminImpersonating">
          <div class="alert alert-danger" role="alert">
            <p class="text-center mb-0">Caution! You are currently impersonating user: {{ userEmail }}</p>
          </div>
        </ng-container>
      </ng-container>
      <div class="trustbox-wrapper">
        <app-trustbox />
      </div>
    </div>
  </div>
</header>